import { render, staticRenderFns } from "./BoardArchives.vue?vue&type=template&id=63de9711&"
import script from "./BoardArchives.vue?vue&type=script&lang=js&"
export * from "./BoardArchives.vue?vue&type=script&lang=js&"
import style0 from "./BoardArchives.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports